// User Redux States
import { SET_USER, SET_PROVIDER, SET_CHAIN_ID, STORE_USER_KYC, SET_KYC_SIGNATURE } from "./actionTypes";
import Web3 from "web3";

const INIT_STATE = {
  address: null,
  loadingState: "NOT_LOADED",
  // NOT_LOADED -> Loading -> LOADED
  //                       \-> ERROR
  error: {
    message: "",
  },
  chainId: null,
  providerId: null,
  canTransact: false,
  signs: {},
  kycProcess: {
    kycSignature: null,
  },
};

function modifyNode(state, path, newValueFn) {
  if (path.length === 1) return { ...state, [path[0]]: newValueFn(state[path[0]] || {}) };
  else {
    return { ...state, [path[0]]: modifyNode(state[path[0]] || {}, path.slice(1, path.length), newValueFn) };
  }
}

const UserReducer = (state = INIT_STATE, action) => {
  let newState = state;
  switch (action.type) {
    case SET_USER: {
      const checkSummedAddress = action.payload && Web3.utils.toChecksumAddress(action.payload);
      const kycProcessLocalStorage =
        JSON.parse(localStorage.getItem(`kycProcess_${checkSummedAddress}`)) || INIT_STATE.kycProcess; // Persistency in case reload page
      if (kycProcessLocalStorage.kycStatus === "inProgress") {
        // backward compatibility
        kycProcessLocalStorage.kycStatus = "idenfyError";
      }
      newState = {
        ...state,
        address: checkSummedAddress,
        canTransact: action.canTransact,
        kycProcess: kycProcessLocalStorage,
      };
      break;
    }

    case SET_CHAIN_ID:
      newState = { ...state, chainId: Number(action.payload) };
      break;

    case SET_PROVIDER:
      newState = { ...state, providerId: action.payload };
      break;

    case STORE_USER_KYC: {
      const key = `${action.key}_${action.userAddress}`;
      const dict = { userAddress: action.userAddress, args: action.args };
      newState = modifyNode(state, ["signs", key], () => dict);
      break;
    }

    case SET_KYC_SIGNATURE:
      newState = {
        ...state,
        kycProcess: { ...state.kycProcess, kycSignature: action.kycSignature },
      };
      break;
    default:
      break;
  }

  if (newState.kycProcess !== state.kycProcess && newState.address) {
    localStorage.setItem(`kycProcess_${newState.address}`, JSON.stringify(newState.kycProcess));
  }

  return newState;
};

export default UserReducer;
